/* eslint-disable no-undef */
import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
// import store from './store'
import environment from "@/components/Neighborhood/util/environment.js";
import OpenIndicator from "@/components/svg/OpenIndicator.vue";
import mapboxgl from "mapbox-gl";
import "mapbox-gl/dist/mapbox-gl.css";
import mitt from "mitt";
import { createPinia } from "pinia";
import piniaPluginPersistedstate from "pinia-plugin-persistedstate";
import "sweetalert2/dist/sweetalert2.min.css";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import VueSweetalert2 from "vue-sweetalert2";
import VueCookies from "vue3-cookies";
import Vue3Toastify from "vue3-toastify";
// import VueGtag from "vue-gtag";
import VueMatomo from "vue-matomo";
import { VueQueryPlugin } from "@tanstack/vue-query";
import 'floating-vue/dist/style.css';
import "./assets/css/tailwind.css";
import "./assets/styles/style.scss";
import {
  FloatingVue,
  // Directives
  vTooltip,
  vClosePopper,
  // Components
  Dropdown,
  Tooltip,
  Menu,
} from 'floating-vue';

const app = createApp(App);
const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);

mapboxgl.accessToken = environment.mapBoxAccessToken;

app.use(VueCookies, {
  expireTimes: "30d",
  path: "/",
  domain: "",
});

vSelect.props.components.default = () => ({
  OpenIndicator,
});

app.component("v-select-component", vSelect);
app.directive('tooltip', vTooltip);
app.directive('close-popper', vClosePopper);
app.component('VDropdown', Dropdown);
app.component('VTooltip', Tooltip);
app.component('VMenu', Menu);
app.use(VueSweetalert2);

app.config.errorHandler = function (err, vm, info) {
  console.error("Vue Error:", err, info);
};

const emitter = mitt();
app.config.globalProperties.emitter = emitter;

app
  .use(Vue3Toastify, {
    theme: "dark",
    autoClose: 3000,
    icon: false,
    containerClassName: "app-toast",
  })
  .use(VueQueryPlugin)
  .use(pinia)
  .use(router)
  .use(VueMatomo, {
    host: "https://matomo.qoo.studio",
    siteId: 1,
    router,
  })
  .mount("#app");
